import { type ReactNode, useEffect } from 'react';

import { twJoin } from 'tailwind-merge';

import { useAuthContext } from '@/_providers/auth-provider';
import { currencyFormat, useBoolean } from '@/_shared';

export function CurrencyWithPrivacy({
  value,
  showCurrency = true,
  className,
}: {
  value: number | string | ReactNode;
  showCurrency?: boolean;
  className?: string;
}) {
  const { dashboardPrivacySettings } = useAuthContext();
  const isPrivacyEnabled = dashboardPrivacySettings[0];
  const [display, setDisplay] = useBoolean(false);

  useEffect(() => {
    if (!isPrivacyEnabled) {
      setDisplay.setTrue();
    } else {
      setDisplay.setFalse();
    }
  }, [isPrivacyEnabled, setDisplay]);

  const handleToggle = () => {
    if (isPrivacyEnabled) {
      setDisplay.toggle();
    }
  };

  return (
    <span
      className={twJoin(
        isPrivacyEnabled && !display ? 'bg-c-card cursor-pointer blur-[5px] select-none' : '',
        className
      )}
      onClick={handleToggle}
    >
      {typeof value === 'number' ? currencyFormat(value, showCurrency) : value}
    </span>
  );
}
